import { Product } from '../models';

export const ifOptionExist = (option: string) => {
  if (option?.length > 0) {
    return ` ${option}`;
  }
  return '';
};

export const getPosibleOptions = (product: Product) => {
  const options = product?.variants?.reduce((acc, variant) => {
    const option1 = variant?.option?.option1;
    const option2 = variant?.option?.option2;
    const option3 = variant?.option?.option3;
    if (variant.active) {
      acc.push({
        variant,
        value: `${option1}${ifOptionExist(option2)}${ifOptionExist(option3)}`,
      });
    }
    return acc;
  }, []);
  return options;
};
